/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

interface IPagination {
  selectedPage: number;
  onPageChange: Function;
}

const PaginationComponent: React.FC<IPagination> = ({
  selectedPage,
  onPageChange,
}) => {
  const handlePrevious = () => {
    onPageChange(Number(selectedPage) - 1);
  };

  const handleNext = () => {
    onPageChange(Number(selectedPage) + 1);
  };

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center gap-2">
        <Button
          className="hover:bg-gray-100 pl-2"
          variant="outline"
          onClick={handlePrevious}
          disabled={selectedPage === 1}
        >
          <ChevronLeft className="mr-2" /> Previous
        </Button>
        <div className="px-4 py-2 rounded-lg border bg-[#31667F] text-white text-base">
          {selectedPage}
        </div>
        <Button
          className="hover:bg-gray-100 pr-2"
          variant="outline"
          onClick={handleNext}
        >
          Next <ChevronRight className="ml-2" />
        </Button>
      </div>
    </div>
  );
};

export default PaginationComponent;